module.exports = "https://cdn.realtymogul.com/static/media/HIW_steps_4.c3a3ca5a.jpg";